// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"14":"426c9ef08d410dd72f8e","492":"21ba5661655cf8786dbe","818":"afa8b48e365da4bc35d0"}[chunkId] + ".chunk.js";
};